import { ExtrudeGeometry, Group, Mesh, MeshPhysicalMaterial, Shape } from 'three';

function createBentCornerProfileShape(size, cornerSize) {
  const shape = new Shape();
  const pw = size;
  const cs = cornerSize;
  shape.moveTo(cs, 0);
  shape.lineTo(pw - cs, 0);
  shape.lineTo(pw, cs);
  shape.lineTo(pw, pw - cs);
  shape.lineTo(pw - cs, pw);
  shape.lineTo(cs, pw);
  shape.lineTo(0, pw - cs);
  shape.lineTo(0, cs);
  shape.closePath();
  return shape;
}
export function createDynamicWallElement(wallType, width, height) {
  if (wallType?.variant === 'no_wall_cladding') {
    const wall = new Group();

    const pw = 0.15;
    const profileGeo = new ExtrudeGeometry(createBentCornerProfileShape(pw, 0.008), {
      depth: height,
      bevelEnabled: false,
    });
    profileGeo.rotateX(Math.PI / 2);
    profileGeo.translate(-pw / 2, height / 2, -pw / 2);

    const tw = 0.1;
    const topWidth = width - pw;
    const topGeo = new ExtrudeGeometry(createBentCornerProfileShape(tw, 0.004), {
      depth: topWidth,
      bevelEnabled: false,
    });
    topGeo.rotateY(Math.PI / 2);
    topGeo.translate(-topWidth / 2 + pw / 2, 0, 0);

    const material = new MeshPhysicalMaterial({
      roughness: 0.39,
      metalness: 0.72,
      clearcoat: 0.32,
      reflectivity: 0.5,
      ior: 1.5,
      sheen: 0,
    });

    const profile = new Mesh(profileGeo, material);
    const top = new Mesh(topGeo, material);
    top.position.set(0, height / 2 - tw, 0);
    const top2 = new Mesh(topGeo, material);
    top2.position.set(0, height / 2 - tw - 0.5, 0);
    top2.name = 'struts';
    top2.visible = false;
    wall.add(profile, top, top2);

    profile.position.set(-width / 2 + pw / 2, 0, -pw / 2);
    wall.userData.width = width;
    return wall;
  }
}
